<body [ngClass]="{'darkMode': darkMode}">
  <div class="container">

    <div class="heading">
      <h1><b>Attributions</b></h1>
    </div>

    <div class="individuals">
      <h6><b>Auth0 Inc.</b> &#64;auth0/angular-jwt: Copyright (c) 2017 Auth0 Inc.</h6>
      <h6><b>.NET Foundation.</b> &#64;microsoft/signalr: Copyright (c) .NET Foundation. All rights reserved. http://www.apache.org/licenses/LICENSE-2.0</h6>
      <h6><b>jQuery Foundation and other contributors.</b> jquery: Copyright jQuery Foundation and other contributors. Released under the MIT license</h6>
      <h6><b>Connor Atherton</b> loaders.css: Copyright (c) 2015 Connor Atherton</h6>
      <h6><b>ngx-bootstrap:</b><br>
        <ul>
          <li><b>Valor Software</b> Copyright (c) 2015-2020 Valor Software<br></li>
          <li><b>Dmitriy Shekhovtsov</b> Copyright (c) 2015-2020 Dmitriy Shekhovtsov&lt;valorkin&#64;gmail.com&gt;</li>
        </ul>
      </h6>
     <h6><b>Scott Cooper</b> ngx-color: Copyright (c) Scott Cooper</h6>
     <h6><b>JS Daddy</b> ngx-mask: Copyright (c) 2018 JS Daddy</h6>
     <h6><b>Vitalii</b> ngx-material-timepicket: Copyright (c) 2018 Vitalii </h6>
     <h6><b>Semen Bobrov</b> ngx-sortablejs: Copyright (c) 2016 Semen Bobrov</h6>
     <h6><b>Federico Zivolo</b> popper.js: Code and documentation copyright 2016 Federico Zivolo</h6>
     <h6><b>Google, Inc., Netflix, Inc., Microsoft Corp. and contributors</b> rxjs: Copyright (c) 2015-2018 Google, Inc., Netflix, Inc., Microsoft Corp. and contributors Licensed under the Apache License</h6>
     <h6><b>sortablejs</b>: Copyright (c) 2019 <b>All contributors</b> to Sortable</h6>
     <h6><b>typescript-eslint and other contributors</b> &#64;typescript-eslint/eslint-plugin: Copyright (c) 2019 typescript-eslint and other contributors</h6>
     <h6><b>JS Foundation and other contributors</b> &#64;typescript-eslint/parser: Copyright JS Foundation and other contributors, https://js.foundation</h6>
     <h6><b>Sindre Sorhus</b> - del: Copyright (c) Sindre Sorhus &lt;sindresorhus&#64;gmail.com&gt; (https://sindresorhus.com)</h6>
     <h6><b>OpenJS Foundation and other contributors</b> eslint: Copyright OpenJS Foundation and other contributors, &lt;www.openjsf.org&gt;</h6>
     <h6><b>Blaine Bublitz & Eric Schoffstall</b> gulp: Copyright (c) 2013-2018 Blaine Bublitz &lt;blaine.bublitz&#64;gmail.com&gt;, Eric Schoffstall &lt;yo&#64;contra.io&gt; and other contributors</h6>
     <h6><b>Jacob Gable</b> gulp-cache: Copyright (c) 2014 - present Jacob Gable</h6>
     <h6><b>Sindre Sorhus</b> gulp-imagemin: Copyright (c) Sindre Sorhus &lt;sindresorhus&#64;gmail.com&gt; (https://sindresorhus.com)</h6>
     <h6><b>Steve Lacy</b> gulp-open: Copyright (c) 2015 Steve Lacy me&#64;slacy.me</h6>
     <h6><b>Hayley Parra</b> gulp-rename: Copyright (c) 2013 Hayley Parra</h6>
     <h6><b>Pivotal Labs</b> jasmine-core: Copyright (c) 2008-2019 Pivotal Labs</h6>
     <h6><b>Bastien Caudan</b> jasmine-spec-reporter: Copyright 2014 Bastien Caudan</h6>
     <h6><b>Matt Lewis</b> karma-coverage-istanbul-reporter: Copyright (c) 2017 Matt Lewis</h6>
     <h6><b>Vojta Jína and contributors.</b> karma-jasmine-html-reporter: Copyright (C) 2011-2013 Vojta Jína and contributors.</h6>
     <h6><b>Blake Embrey</b> ts-node: Copyright (c) 2014 Blake Embrey (hello&#64;blakeembrey.com)</h6>
    </div>

    <div class = "James">
      <h5><br><b>James Henry</b><br>Copyright (c) 2020 James Henry</h5>
      <ul>
        <li>&#64;angular-eslint/builder</li>
        <li>&#64;angular-eslint/eslint-plugin</li>
        <li>&#64;angular-eslint/eslint-plugin-template</li>
        <li>&#64;angular-eslint/schematics</li>
        <li>&#64;angular-eslint/template-parser</li>
      </ul>
    </div>

    <div class = "google">
      <h5><b>Google, Inc.</b><br>Copyright (c) 2017 Google, Inc.</h5>
      <ul>
        <li>&#64;angular-devkit/build-angular</li>
        <li>&#64;angular/cli</li>
      </ul>
      <h5>Copyright Google LLC All Rights Reserved.</h5>
      <ul>
        <li>&#64;angular/compiler-cli</li>
        <li>&#64;angular/language-service</li>
      </ul>
      <h5>Copyright (C) 2011-2013 Google, Inc..</h5>
     <ul>
       <li>karma-chrome-launcher</li>
       <li>karma-jasmine</li>
     </ul>
     <h5>Misc Copyright Google</h5>
     <ul>
      <li>karma: Copyright (C) 2011-2021 Google, Inc.</li>
      <li>zone.js: Copyright (C) 2010-2022 Google LLC. https://angular.io/license</li>
     </ul>


    </div>

    <div class = "angular">
      <h5><br><b>Angular</b><br>Copyright (c) 2010-2022 Google LLC. https://angular.io/license</h5>
      <ul>
        <li>&#64;angular/animations</li>
        <li>&#64;angular/cdk</li>
        <li>&#64;angular/common</li>
        <li>&#64;angular/compiler</li>
        <li>&#64;angular/core</li>
        <li>&#64;angular/forms</li>
        <li>&#64;angular/localize</li>
        <li>&#64;angular/material</li>
        <li>&#64;angular/platform-browser</li>
        <li>&#64;angular/platform-browser-dynamic</li>
        <li>&#64;angular/router</li>
        <li>&#64;ng-bootstrap/ng-bootstrap:  Copyright (c) 2015-2018 <b>Angular ng-bootstrap team</b></li>
        <li>protractor: Copyright (c) 2010-2017 Google, Inc.</li>
      </ul>
    </div>

    <div class = "microsoft">
      <h5><b><br>Microsoft Corporation</b><br>Copyright (c) Microsoft Corporation.</h5>
      <ul>
        <li>&#64;microsoft/applicationinsights-web</li>
        <li>&#64;types/jasmine</li>
        <li>&#64;types/jasminewd2</li>
        <li>&#64;types/jest</li>
        <li>&#64;types/node</li>
        <li>tslib</li>
        <li>typescript</li>
      </ul>

    </div>


  </div>
</body>

